
import route from './route';
import message from './message';
import layout from './layout';

export default {
  index: {
    title1: '기술로 글로벌 교육 발전을 추진하다',
    title2: '',
    subTitle: '20년 이상의 신뢰 | 기술 혁신으로 교육에 힘을 실어주다',
    legacyEvolutionTitle: '우리의 유산, 우리의 발전',
    legacyEvolutionDesc1: '{brand}은(는) 20여 년 동안 해외 유학 지원 및 서비스 업계에서 신뢰받는 리더로 자리매김해 왔습니다. 처음에는 글로벌 교육 여정을 간소화하는 것이 우리의 사명이었으나, 오늘날 우리는 에듀테크(EdTech) 기업으로 성장하여 에이전시, 학교, 그리고 학생들의 국제 교육 경험을 재정의하는 데 앞장서고 있습니다.',
    legacyEvolutionDesc2: '수십 년간의 업계 경험을 바탕으로 우리는 글로벌 교육 분야의 주요 난제를 파악하고 해결해 왔으며, 전통적인 서비스를 더 빠르고, 더 스마트하며, 더 개인화된 기술 기반 솔루션으로 탈바꿈시켰습니다.',
    ecosystemTitle: '우리의 핵심 생태계',
    ecosystemDesc: '우리는 해외 유학 여정의 모든 단계를 포괄하는 다양하고 통합적인 교육 플랫폼을 구축하여, 에이전시, 학교, 학생 모두가 중단이나 지연 없이 원활한 학습 과정을 경험할 수 있도록 보장하고 있습니다.',
    ecosystemType1: '에이전시',
    ecosystemTypeDesc1: 'B2B 에이전시 플랫폼, 에이전시 위챗(WeChat) 미니 프로그램',
    ecosystemType2: '학교',
    ecosystemTypeDesc2: 'B2B2C 브랜드 플랫폼, 교육 보조 플랫폼',
    ecosystemType3: '학생',
    ecosystemTypeDesc3: '학생 플랫폼, 숙소, 보험, 학습 센터',
    whyPartner1: '왜 선택해야 할까요? ',
    whyPartner2: '与{brand}',
    whyPartner3: '?',
    reasonTitle1: '>20 수년간의 신뢰',
    reasonDesc1: '우리는 글로벌 교육 산업의 모든 측면을 이해하고 있으며, 에이전시, 학교, 학생들을 위한 실질적인 문제 해결에 대한 검증된 실적을 보유하고 있습니다. ',
    reasonTitle2: '기술 기반 효율성',    
    reasonDesc2: 'AI 자동화, 연중무휴 24시간 지원, 통합 플랫폼을 통해 시간을 절약하고 비용을 절감하며 오류를 최소화할 수 있습니다.',
    reasonTitle3: '종합적인 지원',
    reasonDesc3: '신청부터 도입(및 그 이후)까지 모든 단계를 지원하므로 여러 공급업체와 협력할 필요가 없습니다.',
    majorSysTitle1: '주요 시스템:',
    majorSysTitle2: '원활한 운영 지원',
    majorSysDesc: '당사의 핵심 시스템은 워크플로를 간소화하고 수작업을 줄이며 원활한 운영을 보장하도록 설계되었습니다. 내부 프로세스 관리부터 고객 지원까지 모든 업무를 지원합니다.',
    majorSys1: 'BMS - 내부 ERP 시스템',
    majorSysFunc1: '종합적인 비즈니스 지원\' \'관리\'',
    majorSysFuncDesc1: '영업, 애플리케이션, 고객 프로필 및 운영을 직관적인 플랫폼에 통합합니다.\', ',
    majorSysFuncFeature11: '중앙 집중식 고객 및 애플리케이션 추적',
    majorSysFuncFeature12: '자동화된 워크플로우 관리',
    majorSysFuncFeature13: '즉시 보고 및 분석',
    majorSysFuncFeature14: '원활한 팀 협업',
    majorSys2: 'GEAR - B2B 에이전트 포털',
    majorSysDesc2: 'AI 기반 도구를 사용하여 시간 소모적인 작업을 줄이고 에이전트 생산성을 향상시키도록 특별히 설계되었습니다.',
    majorSysFuncFeature21: '즉시 비즈니스 개요',
    majorSysFuncFeatureDesc21: '대시보드를 방문하여 즉시 \'지원 진행 상황, 수수료 상태 및 고객 업데이트를 추적합니다.',
    majorSysFuncFeature22: 'AI 기반 지원 자동화',
    majorSysFuncFeatureDesc22: '문서 확인, 양식 작성 및 검토 워크플로를 자동화하여 지원 처리 속도를 높입니다.',
    majorSysFuncFeature23: '즉시 교육 기관 및 과정 검색',
    majorSysFuncFeatureDesc23: '전 세계 학교 및 과정에 대한 포괄적인 데이터베이스를 검색하여 몇 분 안에 학생에게 적합한 옵션을 찾으세요.',
    majorSysFuncFeature24: '온라인 수수료 정산',
    majorSysFuncFeatureDesc24: '수수료 요청 제출, 수금\' 디지털 서명을 통해 더 빠른 결제를 받으세요. 더 이상 서류 작업이나 지연이 없습니다.',
    majorSys31: '{brand} 지원 도움말 받기 -',
    majorSys32: '위챗 에이전트 미니 프로그램',
    majorSysDesc3: '여행 중에도 연결 상태를 유지하고 효율적으로 업무 처리',
    majorSysFuncFeature31: '언제 어디서든 자료 이용: 위챗을 통해 해외 유학 가이드, 특정 국가의 지원 절차, 준비 체크리스트 등을 언제 어디서든 이용하세요.',
    majorSysFuncFeature32: 'AI 기반 코스 매칭: 모바일 기기를 통해 학생의 성적, 관심사, 예산에 맞춰 맞춤형 코스를 추천해 드립니다.',
    majorSysFuncFeature33: '주요 이점: 어디에 있든 고객 기회나 중요한 업데이트를 놓치지 마세요.',
    majorSys4: 'B2B2C 웹사이트: 학교 및 유학 에이전트를 위한 브랜딩 솔루션',
    majorSysDesc4: '당사는 강력한 기술을 활용하여 브랜드를 효과적으로 홍보하고 성장을 촉진할 수 있는 맞춤형 화이트 라벨 포털을 제작합니다.\' 등록.\' ',
    majorSysFuncFeature41: '학교 브랜드 포털',
    majorSysFuncFeatureDesc41: '국제 유학 프로그램을 강조하는 완벽하게 맞춤 설정 가능한 플랫폼으로, 학생과 학부모에게 원활한 경험을 제공합니다. 브랜드 이미지를 강화하고 국제 프로그램 지원 절차를 간소화하세요.',
    majorSysFuncFeature42: '에이전트 브랜드 포털',
    majorSysFuncFeatureDesc42: '자체 브랜드로 서비스, 파트너 기관 및 성공 사례를 선보이세요.\' 경쟁에서 앞서나가고, 신뢰를 구축하고, 서비스 제공을 간소화하세요.',
    platformTitle: '전문 플랫폼: 앱을 넘어',
    platformDesc: '당사의 솔루션은 혁신적인 학습 기술을 통해 학생들의 학업 성공과 기관의 학습 목표를 지원합니다.',
    platformFeature1: '온라인 코스 스쿨(OSSD)',
    platformFeatureDesc1: '전 세계 학생들이 이용할 수 있는 온타리오주 공인 고등학교 졸업 프로그램으로, 유연한 시간표를 제공합니다. 학생들이 거주지를 옮기지 않고도 국제적인 학업 요건을 충족할 수 있도록 지원합니다.',
    platformFeature2: 'AI 교육 지원 플랫폼',
    platformFeatureDesc2: '연중무휴 24시간 AI 로봇이 질문에 답변하고, 과제를 채점하고, 개념을 강화하는 등 즉각적인 교육 지원을 제공합니다.\' 참여도를 높이고 학습 성과를 향상시키세요.',
    miniAppTitle: '학생 중심 미니 프로그램',
    miniAppDesc: '저희는 학생들이 해외에서 편안하고 성공적으로 생활할 수 있도록 미니 프로그램을 통해 이러한 "사소한 일"들을 처리해 드립니다. 이를 통해 학생들은 학업에만 집중할 수 있습니다.',
    miniAppApp1: '학습 센터',
    miniAppAppDesc1: '공항 픽업, 학교 등록, 은행 계좌 개설, 긴급 지원 서비스 등 모든 서비스를 한 곳에서 제공합니다. 맞춤형 패키지로 정착 ​​스트레스를 줄여드립니다.',
    miniAppApp2: '유학 프로그램',
    miniAppAppDesc2: '단기 과정을 통해 학생들이 정식 등록 전에 해외 생활을 경험할 수 있습니다. 불안감을 줄이고 자신감을 높이며 정보에 입각한 결정을 내리는 데 도움을 드립니다.',
    miniAppApp3: '전자 영상 인증',
    miniAppAppDesc3: '지원 상태, 합격 통지서, 등록 확인을 위한 안전한 영상 인증 서비스입니다. 사기 위험을 제거하고 안심하고 이용하세요.',
    learnMore: '자세히 알아보기',
    contactUs: '문의하기',
    companyName: 'Global Education Technology',
    companyName1: 'International Education Alliance',
    companyAddress: '홍콩 과학 공원 팍섹콕 1단계 2W 타워 5층 502호',
    companyAddress2: '광둥성 광저우시 톈허구 린허둥로 285번지 중후이 라이프센터 8층',
    companyPhone: '852-2110-3835',
    companyPhone2:'+86 20 87564591',
  },
  route,
  message,
  ...layout,
};
